
import React from 'react';

interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  noDecoration?: boolean;
}

export const SectionWrapper: React.FC<SectionWrapperProps> = ({ children, className = '', id, noDecoration = false }) => {
  return (
    <section id={id} className={`w-full max-w-5xl mx-auto px-6 pt-12 pb-8 md:pt-20 md:pb-10 animate-fade-in relative ${className}`}>
      
      {!noDecoration && (
        <>
          {/* 
            Decorative Warm Blobs
            调整：大幅降低不透明度 (opacity-60 -> opacity-20/30)
            配合新的 #fcfbf9 背景，使这些色块仅作为极其隐约的氛围存在，
            避免显得像屏幕上的“污渍”，进一步提升干净、高级的质感。
          */}
          <div className="absolute top-0 left-[-10%] w-64 h-64 bg-amber-100/40 rounded-full blur-3xl -z-10 pointer-events-none opacity-20"></div>
          <div className="absolute bottom-10 right-[-5%] w-72 h-72 bg-rose-100/40 rounded-full blur-3xl -z-10 pointer-events-none opacity-30"></div>
        </>
      )}

      {children}
    </section>
  );
};
